import type { MessageKey } from 'types/LocaleMessageKey';

import { MESSAGE_SUCCESS_DEFAULT } from '@/app/[locale]/store/_consts/discounts';
import type { DiscountContextValues } from '@/app/[locale]/store/_contexts/DiscountProvider';

import _getHasSitewideDiscountOnly from './_getHasSitewideDiscountOnly';
import _getUrlDiscountMessage from './_getUrlDiscountMessage';
import type { DiscountError, UiDiscount } from './types';

interface GetDiscountAppliedMessage
  extends Pick<
    DiscountContextValues,
    'appliedDiscountCode' | 'promotionCodes'
  > {
  campaign: string | null | undefined;
  discountError: DiscountError;
  errorCode: string | null | undefined;
  errorMessage: MessageKey | null;
  isFreeShippingSitewide: boolean;
  isUS: boolean;
  reason: string | null | undefined;
  showHighestDiscountEyebrow: boolean | undefined;
  showUrlDiscount: boolean;
  sitewideDiscounts: string | string[];
  statsigDiscountArray: UiDiscount[];
}

// this is where we determine what discount message (Phrase string) to show
export const _getDiscountAppliedMessage = ({
  appliedDiscountCode,
  campaign,
  errorCode,
  errorMessage,
  discountError,
  showHighestDiscountEyebrow,
  isFreeShippingSitewide,
  isUS,
  promotionCodes,
  reason,
  showUrlDiscount,
  sitewideDiscounts,
  statsigDiscountArray,
}: GetDiscountAppliedMessage): MessageKey | null => {
  const defaultMessage = appliedDiscountCode ? MESSAGE_SUCCESS_DEFAULT : null;
  const discountFound = statsigDiscountArray.find(
    (discountedObj) => discountedObj.discountCode === appliedDiscountCode,
  );
  const campaignFound = statsigDiscountArray.find(
    (discountedObj) => discountedObj.discountCode === campaign,
  );

  const hasSitewideDiscountOnly = _getHasSitewideDiscountOnly(
    promotionCodes,
    showUrlDiscount,
    sitewideDiscounts,
  );

  const urlDiscountMessage = _getUrlDiscountMessage({
    campaign,
    campaignFound,
    defaultMessage,
    discountError,
    discountFound,
    errorCode,
    errorMessage,
    promotionCodes,
    reason,
    showHighestDiscountEyebrow,
    showUrlDiscount,
  });
  if (urlDiscountMessage) return urlDiscountMessage;

  const sitewideFreeShippingMessage = isUS
    ? 'free_shipping_usa'
    : 'free_shipping_row';

  if (hasSitewideDiscountOnly && isFreeShippingSitewide) {
    return sitewideFreeShippingMessage;
  }

  return null;
};
